
//Checkout Template Selection Logic
(function(window, $, undefined){
    var buildRadioButtonSelector = function(checkoutTemplateId) {
        if (checkoutTemplateId) {
            return "input[type=radio][name=checkout_template_selection][value="+checkoutTemplateId+"]";
        }
        return "input[type=radio][name=checkout_template_selection]";
    };

    var buildCheckoutContentSelector = function (checkoutTemplateId) {
        if (checkoutTemplateId) {
            return "div[data-checkout-template-id="+checkoutTemplateId+"]";
        }
        return "div[data-checkout-template-id]";
    };

    var applyCheckoutTemplateSelectedState = function ($checkoutTemplateCard) {
        console.debug('Selected: ', $checkoutTemplateCard);
        $checkoutTemplateCard.addClass('jvz-card-selected');
        //find it's detail section and show it
        var checkoutTemplateId = $checkoutTemplateCard.attr('data-checkout-template-id');
        $(buildCheckoutContentSelector(checkoutTemplateId)).addClass('jvz-card-selected');
    };

    var applyCheckoutTemplateNotSelectedState = function ($checkoutTemplateCard) {
        console.debug('Not Selected: ', $checkoutTemplateCard);
        $checkoutTemplateCard.removeClass('jvz-card-selected');
        //find it's detail section and hide it
        var checkoutTemplateId = $checkoutTemplateCard.attr('data-checkout-template-id');
        $(buildCheckoutContentSelector(checkoutTemplateId)).removeClass('jvz-card-selected');
    };

    /**
     * For each card, figure out if it is selected or not, and modify it's styles accordingly as well as setting
     * the visibility of its detail section
     */
    var applyCheckoutTemplateSelectionStates = function() {
        //assume none will be selected
        var numberOfSelectedCheckoutTemplates = 0;
        //foreach card, determine which state it is in and apply the styles for it and it's detail
        var $allCheckoutTemplateCards = $('.card[data-checkout-template-id]');
        $allCheckoutTemplateCards.each(function(index, value) {
            var $card = $(value);
            var $radio = $card.find(buildRadioButtonSelector(undefined)).first();
            if ($radio.prop('checked')) {
                numberOfSelectedCheckoutTemplates += 1;
                applyCheckoutTemplateSelectedState($card);
            } else {
                applyCheckoutTemplateNotSelectedState($card);
            }
        });
        //Determine if the default detail message should be displayed
        if (numberOfSelectedCheckoutTemplates) {
            $('[data-checkout-template-details]').addClass('jvz-card-selected');
        } else {
            $('[data-checkout-template-details]').removeClass('jvz-card-selected');
        }
    };

    var applyBindings = function() {
        $("a[data-select-checkout-template]").on("click", function(event){
            var checkoutTemplateId = $(event.target).attr('data-select-checkout-template');
            var $cardRadio = $(buildRadioButtonSelector(checkoutTemplateId));
            $cardRadio.prop("checked", true);
            console.debug('cardRadio', $cardRadio);
            applyCheckoutTemplateSelectionStates();
        });
        applyCheckoutTemplateSelectionStates();
    };


    var showLargeTemplateThumb = function() {
        $(".ccc-template-thumb").click(function() {
            var $cccThumbModal = $('#ccc-template-modal-preview');
            var $lgThumbs = $cccThumbModal.find('.ccc-template-thumb-lg');
            
            $lgThumbs.hide();

            $('.ccc-template-thumb-lg[data-template="' + $(this).data('short-name') + '"]').show();

            $cccThumbModal.modal('show');
        });
    };

    $(document).ready(function(){
        applyBindings();
        showLargeTemplateThumb();
    });

})(window, jQuery);
//source data
(function(window, $, undefined){
    var checkoutTemplates = {

    };
    var checkoutContentGroups = {

    };
})(window, jQuery);
    